import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { Routes, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { LoaderService } from '../loader/loader.service';
import { ExternalAuthService, ExternalAuthProviderConfig } from '../auth/external-auth.service';
import { AuthSession } from './auth-session.model';

// jQuery declaration
declare var $;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  // variables
  hide: boolean = false;
  username: any;
  password: any;
  registerForm: FormGroup;
  submitted = false;
  rollId = localStorage.getItem('rollId');
  error: any;
  loginError;
  errorStatus: boolean = false;
  locked: boolean = false;
  googleResponse;
  btn: boolean = false;
  emailErrz: boolean;
  imgUrl;
  ssoProviders: ExternalAuthProviderConfig[] = [];
  isSsoInProgress = false;

  constructor(
    private notifier: NotifierService,
    private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private externalAuthService: ExternalAuthService
  ) {}

  ngOnInit() {
    let submainName = window.location.hostname.split(".")[0];
    this.loginService.getImageUrl(submainName).subscribe(res => {
      this.imgUrl = res;
    });

    $(function() {
      $('#noSpacesField').bind('input', function() {
        $(this).val(function(_, v) {
          return v.replace(/\s+/g, '');
        });
      });
    });
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]]
    });
    this.ssoProviders = this.externalAuthService.getEnabledProviders();
  }

  get f() {
    return this.registerForm.controls;
  }

  // Onsubmit (login function)
  onSubmit() {
    this.submitted = true;
    //  stop here if form is invalid
    if (this.registerForm.invalid) {
      this.errorStatus = false;
      return;
    }

    // document.getElementById('myModal').style.display='block'
    this.loginService.login(this.registerForm.value).subscribe(
      res => {
        const session = this.loginService.getStoredSession();
        if (session) {
          this.navigateAfterLogin(session);
        }
      },
      error => {
        this.errorStatus = true;
        this.error = error.error;
        // document.getElementById('myModal').style.display='none'
        this.notifier.notify('error', this.error.message);
        this.loginError = this.error.message;
        this.locked = this.error.isAccountLocked;
        if (this.locked) {
          $('#myModalz').modal('show');
        }
      }
    );
  }

  startExternalLogin(provider: ExternalAuthProviderConfig) {
    if (!provider || !provider.id || this.isSsoInProgress) {
      return;
    }

    this.isSsoInProgress = true;
    this.registerForm.disable({ emitEvent: false });
    this.btn = false;

    try {
      const callbackUrl = this.buildCallbackUrl();
      this.externalAuthService.beginExternalLogin(provider.id, callbackUrl);
    } catch (error) {
      this.isSsoInProgress = false;
      this.registerForm.enable({ emitEvent: false });
      this.notifier.notify('error', 'Unable to initiate single sign-on. Please try again.');
    }
  }

  private buildCallbackUrl(): string {
    return this.externalAuthService.getSpaCallbackUrl();
  }

  private navigateAfterLogin(session: AuthSession) {
    const navigation = this.loginService.determinePostLoginNavigation(session);
    if (!navigation || !navigation.commands) {
      return;
    }

    if (navigation.showLoader) {
      this.loaderService.show();
    }

    this.router.navigate(navigation.commands);
  }

  validatez() {
    const reg = /^\w+([-+.']\w+)*@\w+([-. ]\w+)*\.\w+([-. ]\w+)*$/;
    if (reg.test(this.registerForm.value.email.trim())) {
      this.emailErrz = false;
    } else {
      this.emailErrz = true;
    }
  }

  // Google captch function
  resolved(captchaResponse: string) {
    this.googleResponse = captchaResponse;
    if (this.googleResponse != null && this.registerForm.value) {
      this.btn = true;
    } else {
      this.btn = false;
    }
  }
}
